import { AgreementApiModel, DealOverview } from '../../models/DealModel';
import emptySliceApi from '../emptyApiSlice';

export interface UpdateDealStatusApiRequest {
  accountId: string;
  dealId: string;
  body: {
    enabled: boolean;
  };
}

export const apiSlice = emptySliceApi.injectEndpoints({
  endpoints: (builder) => ({
    getDealsList: builder.query<AgreementApiModel[], string>({
      query: (accountId) => `v4/accounts/${accountId}/deals`,
      providesTags: ['Deal'],
    }),
    getDealsOverview: builder.query<DealOverview[], string>({
      query: (accountId) => `v4/accounts/${accountId}/deals/overview`,
      providesTags: ['Deal'],
    }),
    updateDealStatus: builder.mutation<void, UpdateDealStatusApiRequest>({
      query: ({ accountId, dealId, body }) => ({
        url: `v4/accounts/${accountId}/deals/${dealId}/status`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['Deal'],
    }),
  }),
});

export const {
  useGetDealsListQuery,
  useUpdateDealStatusMutation,
  useGetDealsOverviewQuery,
} = apiSlice;
